import React, { useEffect, useRef, useState } from 'react';


import Icon from '../../icons/Icons';

//interfaces
import { IconLibrary } from  '@/interfaces/IconLibrary';
import { IUsers} from  '@/interfaces/api/ContentAudience';

import FixedPositionTooltip from '../../global/FixedPositionTooltip';
import useViewPermissionsControl from './ViewPermissionsControl.hooks';
import ViewPermissionHoverListItem from './ViewPermissionsControlItem';
import useParentBlurListener from  '@/components/hooks/utility/useParentBlur';
import { isOrganisationAdmin } from  '@/helpers/OrgSettings';
import { ResourcePermission } from  '@/interfaces/orgSettings';





const ViewPermissionsControl = ({user}: {user:IUsers}) => {
    
    const buttonRef = useRef<HTMLButtonElement>(null)

    const [focusChildId, setFocusChildId] = useState<undefined | string>(undefined)
   
    const {
        showTooltip,
        groups,
        getContentPermissionLevel,
        totalGroups,
        isLoading,
        isOrgAdmin,
        handleTooltipClick,
    } = useViewPermissionsControl({user})


    useParentBlurListener(buttonRef, () => {showTooltip && handleTooltipClick()}, [showTooltip])

    
    useEffect(() => {
        function handleModalScroll(){
            showTooltip && handleTooltipClick()
        }
        document.body.addEventListener('scroll', handleModalScroll,true)

        return () => {
            document.body.removeEventListener('scroll', handleModalScroll)
        }
    }, [showTooltip])


    return (
        <button 
            className='view-audience-permission-groups-container'
            tabIndex={0}
            aria-label={`${getContentPermissionLevel()} - click to see ${user.userName}'s group permissions`}
            onClick={handleTooltipClick}
            ref={buttonRef}
        >
            <FixedPositionTooltip
                parentRef={buttonRef}
                containerQuerySelector='.ReactModal__Content'
                contents={
                    isLoading
                    ? <span>Loading...</span>
                    : <ul role="listbox" aria-activedescendant={focusChildId || undefined}>
                        {groups.map((g) =>
                            <li 
                                key={g.id} 
                                role='option'
                            >
                                <ViewPermissionHoverListItem 
                                    title={g.name}
                                    subTitle={getContentPermissionLevel(g?.permission || ResourcePermission.READ )}
                                    id={g.id}
                                    icon={isOrganisationAdmin(g.permission as ResourcePermission,  g.grantType) ? IconLibrary.USER_COG : IconLibrary.USERS}
                                    adminPermissions={isOrgAdmin}
                                    onFocus={() => setFocusChildId(String(g.id))}
                                    onBlur={() => {setFocusChildId(undefined)}}
                                />
                            </li>
                        )}
                        {totalGroups > groups.length 
                            && <>
                                {isOrgAdmin 
                                 ? <li className='more-groups-list-item'>
                                 <a
                                     className='more-groups'
                                     target={'_blank'}
                                     href={`${window.location.origin}/admin/OrganizationUser/EditGroups/${user.id}`}
                                     onClick={() => handleTooltipClick()}
                                     aria-label={`+ ${totalGroups - groups.length} additional groups, click here to view all other groups - opens in a new tab`}
                                 >
                                     <span>+ {totalGroups - groups.length} more groups</span>
                                     <Icon iconName={IconLibrary.EXTERNAL_LINK} sizeInPx='12' color={'#f9f9f9'}/>
                                 </a>
                             </li>
                             :  <li className='more-groups-list-item'>
                             <div className='more-groups'>
                                 <span>+ {totalGroups - groups.length} more groups</span>
                             </div>
                            </li>
                            }
                        </>}
                    </ul>
                }  
                controlIsOpen={showTooltip}
                setControlIsOpen={() => {showTooltip && handleTooltipClick()}}
                closeOnScrollTarget='.simplebar-content-wrapper'
                manualOffset={{right: 90, top: -30}}
            />
                
            <span className='permission-level-text'>{getContentPermissionLevel()} </span>
        </button>
        
    )
}

export default ViewPermissionsControl
